export const PaginationOrder = {
  ASC: 'ASC',
  DESC: 'DESC'
}
